import React, { useEffect, useRef, useState } from 'react';
import { PageHitCountApi } from '../../../../../shared/Helper';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import { Form, Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import { deleteAsync, getAsync, postAsync, putAsync } from '../../../../../components/helper/axiosHelper';
import { useLocation } from 'react-use';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import DatePickerLayout from '../../../../../components/elements/DatePicker';
import ImageViewModal from '../../../../../components/elements/ImageViewModal';
import SearchFilters from '../../../../../components/elements/SearchFilter';
import ImageUploader from './ImageUploader ';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Modal from './Modal';
import './readPhotoGallery.scss';
import ModalCartSuccessful from '../../../../../components/elements/ModalCartSuccessfull';
const defaultImgSrc = '/img/defaultImg.jpg';
import { printTable } from '../../../../../utils/tableExportUtils';
export default function ReadPhotoGallery() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [values, setValues] = useState({
    imageSrc: defaultImgSrc,
  });
  const [errors, setErrors] = useState({});
  const [apiData, setApiData] = useState([]);
  const [title, setTitle] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [filmingLocation, setFilmingLocation] = useState([]);
  const [filmlocation, setFilmlocation] = useState('');
  const [keywords, setKeywords] = useState('');
  const [link, setLink] = useState('');
  const [files, setFiles] = useState([]);
  const [doc, setDoc] = useState('');
  const [base64URL, setBase64URL] = useState('');
  const [gridModalcreate, setGridModalcreate] = useState(false);
  const [renderLink, setRenderLink] = useState('');
  const [gridModalupdate, setGridModalupdate] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [recordID, setRecordID] = useState(null);
  const [searchTitle, setSearchTitle] = useState('');
  const [multiFile, setMultiFile] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [selectRecordId, setSelectRecordId] = useState(null);

  const toggleShowCreate = (e) => {
    setGridModalcreate(!gridModalcreate);
    setTitleEn('');
    setTitle('');
    // setContent('');
    // setContentEn('');
    setFilmlocation('');
    setKeywords('');
    setBase64URL('');
    setFiles('');
    setPublicationDate('');
    // fileInputRef.current.value = '';
    //getCountries();
  };
  const toggleShowUpdate = () => setGridModalupdate(!gridModalupdate);
  const toggleShowOpen = () => setGridModalOpen(!gridModalOpen);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const todayDate = new Date();

  const epUser = localStorage.getItem('apid');
  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const pageOptions = {
    pageNo: 1,
    pageSize: 20,
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        //console.log('Called', reader);
        baseURL = reader.result;
        //console.log(baseURL);
        resolve(baseURL);
      };
    });
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    const imgSize = selectedFile.size;
    const extension = selectedFile?.name.split('.')[1];
    if ((extension == 'jpg' || extension == 'png' || extension == 'PNG' || extension == 'jpeg') && imgSize <= 2097152) {
      getBase64(selectedFile)
        .then((result) => {
          selectedFile['base64'] = result;
          setBase64URL(result);
          setDoc(result.split(',')[1]);
          setFiles(selectedFile);
          toast.success(t('File uploaded successfully.'));
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        setBase64URL('');
        setDoc('');
        setFiles('');
      }
      toast.error(t('Only PNG, JPG, and JPEG files are allowed. Maximum file size: 2MB.'));
    }
  };

  const validate = () => {
    let result = true;
    if (title === '' || title === null) {
      result = false;
      toast.error(t(`please fill all fields`));
    }
    if (publicationDate === '' || publicationDate === null) {
      result = false;
      toast.error(t(`please fill all fields`));
    }
    // if (filmingLocation === '' || filmingLocation === null) {
    //   result = false;
    //   toast.error(t(`please fill all fields`));
    // }
    if (keywords === '' || keywords === null) {
      result = false;
      toast.error(t(`please fill all fields`));
    }

    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let data = {
        title,
        titleEn,
        // contentEn,
        publicationDate,
        // base64URL,
        filmingLocation: filmingLocation?.countryID,
        keywords,
        // content,
        userID: epUser,
        files,
        IsMultiID: multiFile ? 2 : 1,
      };

      const formData = new FormData();

      formData.append('title', title);
      formData.append('titleEn', titleEn);
      formData.append('publicationDate', publicationDate);
      formData.append('filmingLocation', filmingLocation?.countryID);
      formData.append('keywords', keywords);
      formData.append('userID', epUser);
      formData.append('IsMultiID', multiFile ? 2 : 1);
      {
        multiFile
          ? files.forEach((file) => {
              formData.append('files', file);
            })
          : formData.append('files', files);
      }
      if (
        title == '' ||
        titleEn == '' ||
        keywords == '' ||
        filmingLocation == '' ||
        publicationDate == '' ||
        files == ''
        // base64URL == '' ||
        // contentEn == '' ||
        // contentEn == '' ||
      ) {
        toast.error(t(`please fill all fields`));
      } else {
        const response = await postAsync(
          'CMSPhotoGallery/CreateCMSPhotoGalleryAsync',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
            },
          },
          'multipart/form-data',
        );

        if (response?.statusCode === 200) {
          toast.success(t('Created Successfully'));
          setTitleEn('');
          setTitle('');
          // setContent('');
          // setContentEn('');
          setFilmlocation('');
          setKeywords('');
          setBase64URL('');
          setFiles('');
          setPublicationDate('');
          setDatanotfound(false);
          setIsSubmit(!isSubmit);
          toggleShowCreate(e);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          getData();
        }
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const bodyUpdate = {
    title,
    titleEn,
    // contentEn,
    publicationDate,
    base64URL,
    filmingLocation: filmingLocation?.countryID,
    keywords,
    // content,
    userID: epUser,
    files,
    IsMultiID: multiFile ? 2 : 1,
  };

  const onUpdate = async (id) => {
    // e.preventDefault();
    if (validate()) {
      await putAsync(
        'CMSPhotoGallery/UpdateCMSPhotoGallery',
        bodyUpdate,
        {
          id: id,
        },
        'multipart/form-data',
      )
        .then((response) => {
          if (response?.statusCode === 200) {
            toast.success(`${t('Updated Successfully')}`);
            getData();
            navigate('/readPhotoGallery');
            setGridModalupdate(false);
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const getDataByID = async (id) => {
    try {
      const response = await getAsync(`CMSPhotoGallery/CMSPhotoGalleryGetById`, {
        id: id,
      });

      if (response?.data && response?.data.length > 0) {
        const data = response?.data[0];
        setTitle(data?.title);
        setTitleEn(data?.titleEn);
        const date = data?.publicationDate.split('/');
        const formateddate = `${date[2]}-${date[1]}-${date[0]}`;
        setPublicationDate(formateddate);
        setKeywords(data?.keywords);
        setLink(data?.link);
        setFilmlocation(data?.filmingLocation);
        setDoc(data?.doc);
        // setContent(data?.content);
        // setContentEn(data?.contentEn);
        // toast.info(data?.message);
      } else {
        toast.error(t('Record Not Found.'));
      }
    } catch (err) {
      console.error(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const updateRecordById = (e, id) => {
    e.preventDefault();
    getDataByID(id);
    setRecordID(id);
    toggleShowUpdate();
  };

  const showPreview = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setValues({
          ...values,
          imageFile,
          imageSrc: x.target.result,
        });
        const base64 = x.target.result.split(',').splice(1, 1)[0];
        setDoc(base64);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setValues({
        ...values,
        imageFile: null,
        imageSrc: defaultImgSrc,
      });
    }
  };

  const getData = async () => {
    setIsLoad(true);
    await postAsync(
      `CMSPhotoGallery/GetCMSPhotoGalleryFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
      bodyGet,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setNext(pageOptions.pageNo);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
    (async function () {
      try {
        const response = await getAsync('Utilities/GetCountryList');
        setFilmingLocation(response?.data[0]);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);
  // const getCountries = async () => {
  //   await getAsync('Utilities/GetCountryList')
  //     .then((response) => {
  //       setFilmingLocation(response?.data);
  //     })
  //     .catch((error) => {
  //       toast.error(t('Something went wrong, Please try again!'));
  //     });
  // };
  const SearchFilter = {
    epUserID: epUser,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    cmsTitle: searchTitle,
  };
  const SearchRecord = async () => {
    try {
      setIsLoad(true);
      setDatanotfound(false);
      const response = await postAsync(
        `CMSPhotoGallery/GetCMSPhotoGalleryFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const onDelete = async (id) => {
    await deleteAsync('CMSPhotoGallery/DeleteCMSPhotoGallery', { id: id })
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(`${t('Deleted Successfully')}`);
          setApiData(response?.data);
          getData();
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleDownload = async (e, id, fileName) => {
    e.preventDefault();
    try {
      const response = await getAsync('CMSPhotoGallery/CMSPhotoGalleryGetById', { id: id });
      const link = document.createElement('a');
      link.href = `data:image/png;base64,${response?.data[0]?.doc}`;
      link.download = fileName || 'image.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(t('Error downloading file Please try Again'), error);
    }
  };

  // const handleOnSelectCountry = (selectedCountry) => {
  //   const id = selectedCountry.target.value;
  //   setFilmlocation(id);
  // };

  const bodyGet = {
    epUserID: epUser,
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    //setPageCount(select);
    await postAsync('CMSPhotoGallery/GetCMSPhotoGalleryFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const openModal = async (e, photoGalleryID) => {
    e.preventDefault();
    // const selectedData = apiData?.find((data) => data?.photoGalleryID === photoGalleryID)?.doc;
    try {
      const response = await getAsync('CMSPhotoGallery/CMSPhotoGalleryGetById', {
        id: photoGalleryID,
      });
      setRenderLink(response?.data[0]?.doc);
    } catch (error) {
      console.log(error);
    }
    setGridModalOpen(true);
  };

  const applyErrorClass = (field) =>
    // eslint-disable-next-line no-undef
    field in errors && errors[field] === false ? 'invalid-field' : '';

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row className="text-sm" key={index} items={apiData}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{isActive ? data?.title || '' : data?.titleEn || ''}</Table.Cell>
        <Table.Cell>
          <Stack direction="row" spacing={1}>
            {/* Secondary */}
            {data?.isMultiID == 2 && data?.isParentID == 1 && (
              <Chip
                label={t('Primary')}
                sx={{
                  backgroundColor: '#06703A',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              />
            )}

            {/* Secondary */}
            {data?.isMultiID == 2 && data?.isParentID == 2 && (
              <Chip
                label={t('Secondary')}
                sx={{
                  backgroundColor: '#d6efe0',
                  color: '#06703A',
                  fontWeight: 'bold',
                }}
              />
            )}
          </Stack>
        </Table.Cell>
        <Table.Cell>
          <Stack direction="row" spacing={1}>
            {/* Single */}
            {data?.isMultiID == 1 && <Chip label={t('Single')} variant="outlined" sx={{ fontWeight: 'bold' }} />}
            {/* Multiple */}
            {data?.isMultiID == 2 && <Chip label={t('Multiple')} variant="outlined" sx={{ fontWeight: 'bold' }} />}
          </Stack>
        </Table.Cell>

        {/* <Table.Cell>{isActive ? data?.content || '' : data?.contentEn || ''}</Table.Cell> */}
        <Table.Cell>{data?.publicationDate}</Table.Cell>
        {/* <Table.Cell>{data?.filmingLocation}</Table.Cell> */}
        <Table.Cell>{isActive ? data?.ar_SA : data?.en_US}</Table.Cell>
        <Table.Cell>{data?.keywords}</Table.Cell>
        <Table.Cell>
          {/* Modal Create */}
          <>
            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => openModal(e, data?.photoGalleryID)}
              style={{
                margin: '5px',
              }}
            >
              <VisibilityOutlinedIcon />
            </button>
          </>

          {/* end */}

          <button
            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
            onClick={(e) => handleDownload(e, data?.photoGalleryID, data?.fileName)}
            style={{ margin: '5px' }}
          >
            <FileDownloadOutlinedIcon />
          </button>
        </Table.Cell>

        {/* <Table.Cell>{data?.userID}</Table.Cell> */}
        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
            type="button"
            onClick={(e) => {
              updateRecordById(e, data?.photoGalleryID);
              setGridModalupdate(true);
            }}
          >
            {t('Update')}
          </button>
        </Table.Cell>

        <Table.Cell>
          <button
            onClick={() => {
              // onDelete(data.photoGalleryID),
              setSelectRecordId({
                id: data.photoGalleryID,
                isParentID: data?.isParentID,
                isMultiID: data?.isMultiID,
              }),
                setDeleteAlert(true),
                setIsDelete(true);
            }}
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
          >
            {t('delete')}
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      Title: isActive ? item.title : item.titleEn,
      // Content: isActive ? item.content : item.contentEn,
      'Publication Date': item.publicationDate,
      'Filming Location': isActive ? item?.ar_SA : item?.en_US,
      Keywords: item.keywords,
    }));
    downloadCSV(filteredData, 'Read Photo Gallery');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();

  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('PhotoGallery List')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('cms_title')}</th>
   
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_publicationDate`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_filmingLocation`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_keywords`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.title || '' : data?.titleEn || ''}</td>
            
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.publicationDate}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.ar_SA : data?.en_US}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.keywords}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('cms_title'),
      accessor: (row) => isActive ? row?.title : row?.titleEn
    },
       {
      header: t('cms_publicationDate'),
      accessor: (row) => isActive ? row?.publicationDate  || 'N/A' : row?.publicationDate  || 'N/A'
    },   {
      header: t('cms_filmingLocation'),
      accessor: (row) => isActive ? row?.ar_SA  || 'N/A' : row?.en_US || 'N/A'
    },
    {
      header: t('cms_keywords'),
      accessor: (row) => row?.keywords || 'N/A'
    }

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Photo Gallery List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  return (
    <>
      {!isLogin ? (
        <h1>{t('notAuthorized')}</h1>
      ) : (
        <>
          <div className="container-fluid">
            <div className="row text-center">
              <div className="col-lg-11 flex justify-end my-4">
                <button
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                  onClick={toggleShowCreate}
                >
                  {t('create')}
                </button>
              </div>
            </div>
            <div className="row justify-center flex-row">
              <SearchFilters
                handleSearch={SearchRecord}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'cms_photoGallery'}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={false}
              />
            </div>
            {/* Modal Create */}
            <>
              <MDBModal tabIndex="-1" show={gridModalcreate} setShow={setGridModalcreate}>
                <MDBModalDialog className="flex justify-center items-center">
                  <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                    <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                      <MDBModalHeader>
                        <MDBModalTitle className="text-customgreen font-semibold">
                          {t('create')} {t('cms_photoGallery')}
                        </MDBModalTitle>
                        {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div className="container-fluid bd-example-row">
                          <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Title')} : </label>
                                <input
                                  maxLength={1000}
                                  type="text"
                                  name="title"
                                  value={title}
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  required
                                  onChange={(e) => setTitle(e.target.value)}
                                  placeholder={t('Title')}
                                />
                              </Form.Field>
                            </div>
                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                                <input
                                  maxLength={1000}
                                  type="text"
                                  value={titleEn}
                                  name="content"
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  required
                                  onChange={(e) => setTitleEn(e.target.value)}
                                  placeholder={t('Title En')}
                                />
                              </Form.Field>
                            </div>

                            {/* <div className="col-md-6 col-example">
                              <label className="mx-auto text-customgreen">{t('cms_content')}: </label>
                              <textarea
                                type="text"
                                name="content"
                                value={content}
                                className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                onChange={(e) => setContent(e.target.value)}
                                placeholder={t('cms_content')}
                              />
                            </div> */}

                            {/* <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Content En')} : </label>
                                <textarea
                                  type="text"
                                  name="content"
                                  value={contentEn}
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  required
                                  onChange={(e) => setContentEn(e.target.value)}
                                  placeholder={t('Content En')}
                                />
                              </Form.Field>
                            </div> */}
                          </div>
                          <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_filmingLocation')} : </label>
                                <input
                                  type="text"
                                  name="filmLocation"
                                  disabled
                                  value={isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US}
                                  className="cursor-not-allowed  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  // onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                                  placeholder={t('cms_filmingLocation')}
                                />
                                {/* <option value={0}>--{t('Select Country')}--</option>
                                  {filmingLocation && filmingLocation.length > 0 ? (
                                    filmingLocation?.map((item) => {
                                      return (
                                        <option key={item.countryID} value={item?.countryID}>
                                          {isActive ? item?.ar_SA : item?.countryName}
                                        </option>
                                      );
                                    })
                                  ) : (
                                    <option>{t('Select country')}</option>
                                  )}
                                </select> */}
                              </Form.Field>
                            </div>
                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                                <input
                                  type="text"
                                  name="keywords"
                                  value={keywords}
                                  onChange={(e) => setKeywords(e.target.value)}
                                  required
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  placeholder={t('cms_keywords')}
                                />
                              </Form.Field>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <div className="form-group flex flex-col ">
                                  <DatePickerLayout
                                    label={'cms_publicationDate'}
                                    selectedDate={publicationDate}
                                    keyValue={'to'}
                                    dateTo={publicationDate}
                                    setDateTo={setPublicationDate}
                                    maxDate={todayDate}
                                  />
                                </div>
                              </Form.Field>
                            </div>
                            <div className="col-md-6 col-example">
                              {!multiFile && (
                                <Form.Field>
                                  <label className="mx-auto text-customgreen">{t('cms_image')}</label>
                                  <input
                                    multiple
                                    ref={fileInputRef}
                                    onChange={handleFileInputChange}
                                    type="file"
                                    className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  />
                                </Form.Field>
                              )}

                              {/* <img style={{ height: '120px', width: '150px' }} src={values.imageSrc} className="card-img-top" /> */}
                            </div>
                            <div className="mx-2 col-md-6 col-example mt-3">
                              <div className="flex">
                                <label className=" mx-1 order-1 text-customgreen">{t('Select Multiple files')}</label>
                                <input
                                  type="checkbox"
                                  onClick={() => {
                                    setMultiFile(!multiFile), setFiles([]), setBase64URL('');
                                  }}
                                  className=" h-8 w-8 sm:h-6 sm:w-6 text-customgreen focus:ring-customgreen"
                                />
                              </div>
                            </div>
                            <div className="flex flex-wrap justify-center gap-2">
                              {!multiFile && (
                                <div className="flex justify-center mt-2  ">
                                  <div className="" />
                                  <img
                                    style={{
                                      height: '120px',
                                      width: '150px',
                                    }}
                                    src={base64URL ? `${base64URL}` : values.imageSrc}
                                    // onChange={(e) => setLink(e.target.files[0])}
                                    className="card-img-top"
                                    alt=""
                                  />
                                </div>
                              )}

                              {multiFile && (
                                <>
                                  {' '}
                                  <ImageUploader
                                    setFiles={setFiles}
                                    files={files}
                                    multiple={multiFile}
                                    isSubmit={isSubmit}
                                  />
                                  <ImageUploader
                                    setFiles={setFiles}
                                    files={files}
                                    multiple={multiFile}
                                    isSubmit={isSubmit}
                                  />
                                  <ImageUploader
                                    setFiles={setFiles}
                                    files={files}
                                    multiple={multiFile}
                                    isSubmit={isSubmit}
                                  />
                                  <ImageUploader
                                    setFiles={setFiles}
                                    files={files}
                                    multiple={multiFile}
                                    isSubmit={isSubmit}
                                  />
                                  <ImageUploader
                                    setFiles={setFiles}
                                    files={files}
                                    multiple={multiFile}
                                    isSubmit={isSubmit}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter className="flex justify-center">
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                          onClick={(e) => {
                            handleSubmit(e);
                          }}
                        >
                          {t('create')}
                        </button>
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={toggleShowCreate}
                        >
                          {t('close')}
                        </button>
                      </MDBModalFooter>
                    </Form>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>
            {/* Modal Create End */}

            {/* Modal Update */}
            <>
              <Modal
                updateRecordById={updateRecordById}
                t={t}
                gridModalupdate={gridModalupdate}
                setGridModalupdate={setGridModalupdate}
                title={title}
                titleEn={titleEn}
                setTitleEn={setTitleEn}
                // content={content}
                // setContentEn={setContentEn}
                // contentEn={contentEn}
                setTitle={setTitle}
                publicationDate={publicationDate}
                setPublicationDate={setPublicationDate}
                filmlocation={filmlocation}
                // handleOnSelectCountry={handleOnSelectCountry}
                filmingLocation={filmingLocation}
                keywords={keywords}
                setKeywords={setKeywords}
                showPreview={showPreview}
                applyErrorClass={applyErrorClass}
                link={link}
                doc={doc}
                setDoc={setDoc}
                values={values}
                setLink={setLink}
                // setContent={setContent}
                onUpdate={onUpdate}
                recordID={recordID}
                onChange={handleFileInputChange}
                fileInputRef={fileInputRef}
              />
            </>
            {/* end */}

            {/* Image View Modal */}

            <ImageViewModal
              showModal={gridModalOpen}
              setShowModal={setGridModalOpen}
              closeModal={toggleShowOpen}
              title={''}
              renderLink={''}
              imgDoc={renderLink}
            />
            {/*  Image View Modal End */}

            <div className="flex flex-col pt-9">
              <div className="row justify-center pb-5 ">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="col-lg-11 text-center">
                    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                      <Table className="text-sm tableData text-center  rtl:text-right ">
                        <Table.Header className="font-bold  text-white whitespace-nowrap bg-customgreen uppercase ">
                          <Table.Row>
                            <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_title')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Primary / Secondary')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Single / Multiple')}</Table.HeaderCell>
                            {/* <Table.HeaderCell className="text-white">{t('cms_content')}</Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white">{t('cms_publicationDate')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_filmingLocation')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_keywords')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('')}</Table.HeaderCell>
                            {/* <Table.HeaderCell>{t('cms_userID')}</Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                            <Table.HeaderCell>{t('')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>{displayRecords}</Table.Body>
                      </Table>
                      {datanotfound && <DataNotFound />}
                    </div>

                    {pageCount > 0 && (
                      <div className="flex flex-row px-12 justify-between">
                        <Menu pagination>
                          <Menu.Item>
                            <ReactPaginate
                              previousLabel={t('Previous')}
                              nextLabel={t('Next')}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={'paginationButtons'}
                              previousLinkClassName={'previousButton'}
                              nextLinkClassName={'nextButton'}
                              disabledClassName={'paginationDisabled'}
                              activeClassName={'paginationActive'}
                            />
                          </Menu.Item>
                        </Menu>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <ModalCartSuccessful
            modalMessageText={
              selectRecordId?.isMultiID == 2 && selectRecordId?.isParentID == 1
                ? 'Are your sure you want to delete Primary and Secondary Records. if yes then all parent and its child records will be deleted'
                : 'Are you sure you want to delete?'
            }
            onDelete={onDelete}
            modalExist={true}
            isDelete={isDelete}
            selectRecordId={selectRecordId}
            setGridModalOpen={setDeleteAlert}
            gridModalOpen={deleteAlert}
          />
        </>
      )}
    </>
  );
}
